import { useState } from 'react';
import { TabNav, TabNavItem, TabPanel, Tabs } from '@round/ui-kit';
import TiktokTopPosts from 'Modules/Plans/TopPosts/TikTokTopPosts/TikTokTopPosts';
import styles from './TiktokData.module.css';
import TiktokTopAudios from '../TopAudios/Tiktok/TiktokTopAudios';
import { useSong, useMusicSong } from '@round/creatorbase-helpers/api-hooks';
import { getMergedAudioIdsFromSongData } from '../helpers';

type Props = {
    songId: number | null | undefined;
};

type TableTab = 'top-audios' | 'top-posts';

const TiktokData = ({ songId }: Props) => {
    const [activeTable, setActiveTable] = useState<TableTab>('top-audios');
    const { data: song, isLoading: isSongLoading } = useSong(songId);
    const { data: musicSong, isLoading: isMusicSongLoading } = useMusicSong(song?.music_song_id);
    const { tiktokAudioIds } = getMergedAudioIdsFromSongData(song, musicSong);

    return (
        <Tabs activeTab={activeTable} onChange={setActiveTable}>
            <TabNav indicatorClassName={styles.activeTabIndicator} trackClassName={styles.activeTabIndicatorTrack}>
                <TabNavItem name="top-audios" className={styles.tabItem} activeClassName={styles.activeTab}>
                    Top Audios
                </TabNavItem>
                <TabNavItem name="top-posts" className={styles.tabItem} activeClassName={styles.activeTab}>
                    Top Posts
                </TabNavItem>
            </TabNav>

            <TabPanel name="top-audios">
                <TiktokTopAudios songId={songId} />
            </TabPanel>

            <TabPanel name="top-posts">
                <TiktokTopPosts
                    shouldDisplayAudio
                    className={styles.container}
                    audioIds={isSongLoading || isMusicSongLoading ? [] : tiktokAudioIds}
                />
            </TabPanel>
        </Tabs>
    );
};

export default TiktokData;
